module.exports = require("d3-shape");